import {ROUTE_PARAMETERS_SET_VALUE} from "../../config/actions";

export const setRouteParameterValue = (name, value) => {
    return {
        type: ROUTE_PARAMETERS_SET_VALUE,
        name,
        value
    }
};
